// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface AuditEvent
 */
export interface AuditEvent {
  /**
   * Action is the API operation that made the change, e.g.
   * "PATCH /v1/clusters/:id/status". Absent for changes made outside the API.
   * @type {string}
   * @memberof AuditEvent
   */
  action?: string;
  /**
   *
   * @type {string}
   * @memberof AuditEvent
   */
  actor?: string;
  /**
   *
   * @type {string}
   * @memberof AuditEvent
   */
  actorRole?: string;
  /**
   *
   * @type {string}
   * @memberof AuditEvent
   */
  actorType?: AuditEventActorTypeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof AuditEvent
   */
  changedFields?: Array<string>;
  /**
   * Changes maps each changed column to {"old": ..., "new": ...}: every
   * column on create (old is null), the final row on delete (new is null).
   * @type {object}
   * @memberof AuditEvent
   */
  changes?: object;
  /**
   *
   * @type {string}
   * @memberof AuditEvent
   */
  entityId?: string;
  /**
   *
   * @type {string}
   * @memberof AuditEvent
   */
  entityKind?: AuditEventEntityKindEnum;
  /**
   *
   * @type {string}
   * @memberof AuditEvent
   */
  entityName?: string;
  /**
   *
   * @type {string}
   * @memberof AuditEvent
   */
  environment?: string;
  /**
   *
   * @type {number}
   * @memberof AuditEvent
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof AuditEvent
   */
  occurredAt?: string;
  /**
   *
   * @type {string}
   * @memberof AuditEvent
   */
  onBehalfOf?: string;
  /**
   *
   * @type {string}
   * @memberof AuditEvent
   */
  operation?: AuditEventOperationEnum;
  /**
   *
   * @type {string}
   * @memberof AuditEvent
   */
  reason?: string;
  /**
   *
   * @type {string}
   * @memberof AuditEvent
   */
  sourceRef?: string;
  /**
   * TransactionID is shared by every event one request wrote, e.g. one
   * catalog sync, or a delete and the cluster references it cleared.
   * @type {number}
   * @memberof AuditEvent
   */
  transactionId?: number;
}

/**
 * @export
 */
export const AuditEventActorTypeEnum = {
  ServiceAccount: 'service_account',
  Human: 'human',
  Database: 'database',
} as const;
export type AuditEventActorTypeEnum =
  (typeof AuditEventActorTypeEnum)[keyof typeof AuditEventActorTypeEnum];

/**
 * @export
 */
export const AuditEventEntityKindEnum = {
  Cluster: 'cluster',
  Partition: 'partition',
  IsolationUnit: 'isolation_unit',
} as const;
export type AuditEventEntityKindEnum =
  (typeof AuditEventEntityKindEnum)[keyof typeof AuditEventEntityKindEnum];

/**
 * @export
 */
export const AuditEventOperationEnum = {
  Create: 'create',
  Update: 'update',
  Delete: 'delete',
} as const;
export type AuditEventOperationEnum =
  (typeof AuditEventOperationEnum)[keyof typeof AuditEventOperationEnum];

/**
 * Check if a given object implements the AuditEvent interface.
 */
export function instanceOfAuditEvent(value: object): value is AuditEvent {
  return true;
}

export function AuditEventFromJSON(json: any): AuditEvent {
  return AuditEventFromJSONTyped(json, false);
}

export function AuditEventFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuditEvent {
  if (json == null) {
    return json;
  }
  return {
    action: json['action'] == null ? undefined : json['action'],
    actor: json['actor'] == null ? undefined : json['actor'],
    actorRole: json['actor_role'] == null ? undefined : json['actor_role'],
    actorType: json['actor_type'] == null ? undefined : json['actor_type'],
    changedFields:
      json['changed_fields'] == null ? undefined : json['changed_fields'],
    changes: json['changes'] == null ? undefined : json['changes'],
    entityId: json['entity_id'] == null ? undefined : json['entity_id'],
    entityKind: json['entity_kind'] == null ? undefined : json['entity_kind'],
    entityName: json['entity_name'] == null ? undefined : json['entity_name'],
    environment: json['environment'] == null ? undefined : json['environment'],
    id: json['id'] == null ? undefined : json['id'],
    occurredAt: json['occurred_at'] == null ? undefined : json['occurred_at'],
    onBehalfOf: json['on_behalf_of'] == null ? undefined : json['on_behalf_of'],
    operation: json['operation'] == null ? undefined : json['operation'],
    reason: json['reason'] == null ? undefined : json['reason'],
    sourceRef: json['source_ref'] == null ? undefined : json['source_ref'],
    transactionId:
      json['transaction_id'] == null ? undefined : json['transaction_id'],
  };
}

export function AuditEventToJSON(json: any): AuditEvent {
  return AuditEventToJSONTyped(json, false);
}

export function AuditEventToJSONTyped(
  value?: AuditEvent | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    action: value['action'],
    actor: value['actor'],
    actor_role: value['actorRole'],
    actor_type: value['actorType'],
    changed_fields: value['changedFields'],
    changes: value['changes'],
    entity_id: value['entityId'],
    entity_kind: value['entityKind'],
    entity_name: value['entityName'],
    environment: value['environment'],
    id: value['id'],
    occurred_at: value['occurredAt'],
    on_behalf_of: value['onBehalfOf'],
    operation: value['operation'],
    reason: value['reason'],
    source_ref: value['sourceRef'],
    transaction_id: value['transactionId'],
  };
}
